import ExceptionHandling from "./ExceptionHandling.js";
import { useStore, ActionTypes } from "../store";
import instance from "./index";

export default class StockTransferService {

    getTransfers(keyword, start, direction = 'all', status = '') {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("keyword", keyword);
        formData.append("start", start);
        formData.append("direction", direction);
        formData.append("status", status);
        return instance()({ method: "post", url: "/api/transfer_list", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    initiateTransfer(toBranchId, items, notes) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("to_branch_id", toBranchId);
        formData.append("items", JSON.stringify(items));
        formData.append("notes", notes || "");
        return instance()({ method: "post", url: "/api/initiate_transfer", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    receiveTransfer(transferId, receivedItems, notes) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("transfer_id", transferId);
        formData.append("received_items", JSON.stringify(receivedItems));
        formData.append("notes", notes || "");
        return instance()({ method: "post", url: "/api/receive_transfer", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    completeTransfer(transferId, notes) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("transfer_id", transferId);
        formData.append("notes", notes || "");
        return instance()({ method: "post", url: "/api/complete_transfer", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    cancelTransfer(transferId, cancelReason) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("transfer_id", transferId);
        formData.append("cancel_reason", cancelReason || "");
        return instance()({ method: "post", url: "/api/cancel_transfer", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    getTransferDetail(transferId) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        return instance().get(`/api/get_transfer/${transferId}`)
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    checkFreeze(stockId) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("stock_id", stockId);
        return instance()({ method: "post", url: "/api/check_transfer_freeze", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    getTransferHistoryForStock(stockId) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("stock_id", stockId);
        return instance()({ method: "post", url: "/api/get_transfer_history_for_stock", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    getBranchesForTransfer() {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        return instance().get('/api/transfer_branches')
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    cancelTransferByReceiver(transferId, cancelReason) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("transfer_id", transferId);
        formData.append("cancel_reason", cancelReason || "");
        return instance()({ method: "post", url: "/api/cancel_transfer_receiver", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    approveTransfer(transferId, notes) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("transfer_id", transferId);
        formData.append("notes", notes || "");
        return instance()({ method: "post", url: "/api/approve", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    declineTransfer(transferId, declineReason) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("transfer_id", transferId);
        formData.append("decline_reason", declineReason);
        return instance()({ method: "post", url: "/api/decline", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

    dispatchTransfer(transferId, items, notes) {
        const store = useStore();
        store.dispatch(ActionTypes.PROGRESS_BAR, true);
        const formData = new FormData();
        formData.append("transfer_id", transferId);
        formData.append("items", JSON.stringify(items));
        formData.append("notes", notes || "");
        return instance()({ method: "post", url: "/api/dispatch", data: formData })
            .then(res => res.data)
            .catch(e => ExceptionHandling.HandleErrors(e))
            .finally(() => store.dispatch(ActionTypes.PROGRESS_BAR, false));
    }

}